var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var addLocalCRUDEvents = function (dataProvider) { return (__assign(__assign({}, dataProvider), { create: function (resource, params) {
        return dataProvider.create(resource, params).then(function (res) {
            var id = res.data.id;
            var event = {
                type: 'created',
                payload: { ids: [id], data: res.data },
                date: new Date(),
            };
            // delay the publication to ensure it arrives after a storage event
            // synchronizing localStorage with the other tabs
            setTimeout(function () { return dataProvider.publish("resource/".concat(resource), event); }, 100);
            return res;
        });
    }, update: function (resource, params) {
        return dataProvider.update(resource, params).then(function (res) {
            var id = params.id;
            var event = {
                type: 'updated',
                payload: { ids: [id], data: res.data },
                date: new Date(),
            };
            // delay the publication to ensure it arrives after a storage event
            // synchronizing localStorage with the other tabs
            setTimeout(function () {
                dataProvider.publish("resource/".concat(resource), event);
                dataProvider.publish("resource/".concat(resource, "/").concat(id), event);
            }, 100);
            return res;
        });
    }, delete: function (resource, params) {
        return dataProvider.delete(resource, params).then(function (res) {
            var id = params.id;
            var event = {
                type: 'deleted',
                payload: { ids: [id] },
                date: new Date(),
            };
            // delay the publication to ensure it arrives after a storage event
            // synchronizing localStorage with the other tabs
            setTimeout(function () {
                dataProvider.publish("resource/".concat(resource), event);
                dataProvider.publish("resource/".concat(resource, "/").concat(id), event);
            }, 100);
            return res;
        });
    } })); };
